(function () {
  function initFauxTabs(section) {
    if (!section || section.dataset.splitTabsInit === 'true') return;

    var tabsRoot = section.querySelector('[data-faux-tabs]');
    if (!tabsRoot) return;

    var fauxSelect = tabsRoot.querySelector('[data-faux-select]');
    var toggle = tabsRoot.querySelector('[data-faux-toggle]');
    var label = tabsRoot.querySelector('[data-faux-label]');
    var optionsWrap = tabsRoot.querySelector('[data-faux-options]');
    var options = tabsRoot.querySelectorAll('[data-tab-option]');
    var panels = tabsRoot.querySelectorAll('[data-tab-panel]');

    if (!fauxSelect || !toggle || !label || !optionsWrap || !options.length || !panels.length) return;

    function openSelect() {
      fauxSelect.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }

    function closeSelect() {
      fauxSelect.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    function setActive(index) {
      var activeIndex = parseInt(index, 10);
      if (isNaN(activeIndex)) activeIndex = 0;

      options.forEach(function (option) {
        var optionIndex = parseInt(option.getAttribute('data-tab-index'), 10);
        var isActive = optionIndex === activeIndex;
        option.classList.toggle('is-selected', isActive);
        option.setAttribute('aria-selected', isActive ? 'true' : 'false');

        if (isActive) {
          label.textContent = option.textContent.trim();
        }
      });

      panels.forEach(function (panel) {
        var panelIndex = parseInt(panel.getAttribute('data-tab-index'), 10);
        var isActive = panelIndex === activeIndex;
        panel.classList.toggle('is-active', isActive);

        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', 'hidden');
        }
      });
    }

    toggle.addEventListener('click', function () {
      if (fauxSelect.classList.contains('is-open')) {
        closeSelect();
      } else {
        openSelect();
      }
    });

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        setActive(option.getAttribute('data-tab-index'));
        closeSelect();
      });
    });

    document.addEventListener('click', function (event) {
      if (!section.contains(event.target)) {
        closeSelect();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeSelect();
      }
    });

    setActive(0);
    section.dataset.splitTabsInit = 'true';
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-maxcalm26-split-tabs]');
    sections.forEach(initFauxTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFauxTabs(event.target);
  });
})();
